import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import EcaPageHero from "./components/EcaPageHero";
import EcaIntroSection from "./components/EcaIntroSection";
import EcaWhatWeProvideSection from "./components/EcaWhatWeProvideSection";
import EcaAdvantagesSection from "./components/EcaAdvantagesSection";
import EcaHowItWorksSection from "./components/EcaHowItWorksSection";
import EcaModulesSection from "./components/EcaModulesSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import EcaCtaBanner from "./components/EcaCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "../HospitalManagementPage/hospital-management.css";
import "./e-commerce-app.css";

const ECommerceAppPage: React.FC = () => {
  useEffect(() => {
    document.title = "E-Commerce App | WebTech Software Solutions Bangalore";
    const description =
      "WebTech builds e-commerce apps in Bangalore — customer shopping app, vendor panel, admin dashboard, payments, and order tracking for marketplaces.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <EcaPageHero />
            <EcaIntroSection />
            <EcaWhatWeProvideSection />
            <EcaAdvantagesSection />
            <EcaHowItWorksSection />
            <EcaModulesSection />
            <WdevTestimonials />
            <EcaCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ECommerceAppPage;
